import {
  SCREEN_LG_MIN,
  SCREEN_MD_MAX,
  SCREEN_MD_MIN,
  SCREEN_SM_MAX,
  SCREEN_SM_MIN,
  SCREEN_XS_MAX,
} from '../../const/breakpoint.const';

const breakPoints = {
  extraSmallFormat: {
    min: 0,
    max: SCREEN_XS_MAX,
  },
  smallFormat: {
    min: SCREEN_SM_MIN,
    max: SCREEN_SM_MAX,
  },
  mediumFormat: {
    min: SCREEN_MD_MIN,
    max: SCREEN_MD_MAX,
  },
  largeFormat: {
    min: SCREEN_LG_MIN,
    max: Number.MAX_VALUE,
  },
};

type FormatType = {
  min: number;
  max: number;
};

const isFormat = (format: FormatType, windowWidth: number) => {
  return format.min <= windowWidth && windowWidth <= format.max;
};

export const isXSmallDevice = (windowWidth: number) => {
  return isFormat(breakPoints.extraSmallFormat, windowWidth);
};

export const isSmallDevice = (windowWidth: number) => {
  return isFormat(breakPoints.smallFormat, windowWidth);
};

export const isSmallDeviceOrGreater = (windowWidth: number) => {
  return (
    isSmallDevice(windowWidth) ||
    isMediumDevice(windowWidth) ||
    isLargeDevice(windowWidth)
  );
};

export const isMediumDevice = (windowWidth: number) => {
  return isFormat(breakPoints.mediumFormat, windowWidth);
};

export const isMediumDeviceOrGreater = (windowWidth: number) => {
  return isMediumDevice(windowWidth) || isLargeDevice(windowWidth);
};

export const isLargeDevice = (windowWidth: number) => {
  return isFormat(breakPoints.largeFormat, windowWidth);
};
